import { env } from '@bridebook/toolbox/src/env';

/**
 * Picks the bucket setting value matching the environment the app runs against.
 *
 * Some settings point at records owned by a third party whose test and live
 * accounts hold different ids, so the config has to carry both.
 *
 * Note that `live` also covers staging, which runs against the production database.
 */
export const configByEnv = <T>({ dev, live }: { dev: T; live: T }): T => (env.LIVE ? live : dev);
